<script setup>
import { onMounted } from "vue";

onMounted(() => {
  require("@/assets/js/gratuity.js");
});
</script>
<template>
  <main
    class="upstox-calculators gratuity-calculators"
    id="gratuity-calculator"
  >
    <!-- breadcrumb template -->
    <section class="breadcrumbs-sec">
      <div class="container breadcrumbs-ol">
        <div class="stocks-indices-breadcrumbs_wrap">
          <ol class="stocks-indices-breadcrumbs">
            <li>
              <a href="/">
                <span>Trading </span>
              </a>
            </li>
            <li>
              <a>
                <span>Calculators </span>
              </a>
            </li>
            <li>
              <span>Gratuity Calculator </span>
            </li>
          </ol>
        </div>
      </div>
    </section>
    <!-- end breadcrumb template -->

    <section class="calculator-background"></section>

    <section class="calculator">
      <div class="container">
        <h1 class="title">Gratuity Calculator</h1>
        <div class="cal-structure">
          <div class="inner-row cal-slider" id="cal-slider">
            <div class="input-section calc-slide">
              <div class="calc-slide-inner">
                <div class="form-group investment-main">
                  <label for="investment">
                    <h3 id="investment-title">
                      Monthly Salary (Basic Salary + DA)
                    </h3>
                  </label>
                  <input
                    type="text"
                    id="investment"
                    value="₹ 50000"
                    class="input"
                    data-type="rupee"
                  />
                </div>

                <div class="form-group">
                  <div class="group-merge-main">
                    <label for="investment">
                      <h3 id="investment-title">No. of Years of Service</h3>
                    </label>
                    <input
                      type="text"
                      name="tenure"
                      value="5"
                      step="1"
                      min="5"
                      max="35"
                      id="tenure-input"
                      class="input"
                      data-type="years"
                    />
                  </div>
                  <input
                    type="range"
                    value="5"
                    step="1"
                    min="5"
                    max="35"
                    id="tenure-input-slider"
                    class="slider-range"
                  />
                </div>

                <div class="mob-calc-btn">
                  <button id="calculate" class="calc-btn-mob">Calculate</button>
                </div>
              </div>
            </div>
            <div class="output-section calc-slide cal-loader">
              <div class="calc-slide-inner">
                <lottie-player
                  src="/json-data/lottie/calculator-loader.json"
                  background="transparent"
                  speed="1"
                  loop=""
                  autoplay=""
                ></lottie-player>
              </div>
            </div>
            <div class="output-section calc-slide">
              <div class="calc-slide-inner">
                <div class="mob-results custom_class_mob_gravity">
                  <h5>
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/back-arrow.svg"
                      alt=""
                      id="back-button"
                    />
                    Your results
                  </h5>
                </div>

                <div class="row outer-listing-group">
                  <div class="outer-grp">
                    <h4>Total Gratuity Payable</h4>
                    <span id="total-investment">₹ 2,88,462</span>
                  </div>
                  <div class="bottom-text">
                    <p>
                      <span class="capital-text">ZERO</span> annual maintenance
                      charges only for new users for the
                      <strong>next 10 days</strong>
                    </p>
                    <a
                      href="https://wa.me/+917092362098"
                      class="get-start-btn"
                      >Get Started Today</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--------------last 3 calculations -------------------->

    <section class="last-three-calculations">
      <div class="container last-three-cal-mobile">
        <h3>Last 3 calculations</h3>
        <p>Your calculations are erased upon refreshing!</p>
        <div class="calc-inner" id="cal-history"></div>
      </div>
    </section>

    <!--------------------Start Key Indicies Template--------------------------->

    <section class="key-indices">
      <div class="container">
        <div class="key-indices-inner">
          <div class="key-indices-header">
            <h4>Key Indices in NSE</h4>
          </div>
          <div class="key-indices-content">
            <ul>
              <li>
                <a href="/indices/nifty-50-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="Nifty 50"
                    />
                  </div>
                  <div class="key-content">NIFTY 50</div>
                </a>
              </li>
              <li>
                <a href="/indices/nifty-next-50-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="Nifty Next 50"
                    />
                  </div>
                  <div class="key-content">NIFTY NEXT 50</div>
                </a>
              </li>
              <li>
                <a href="/indices/nifty-bank-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="Nifty Bank"
                    />
                  </div>
                  <div class="key-content">NIFTY BANK</div>
                </a>
              </li>
              <li>
                <a href="/indices/nifty-100-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="Nifty 100"
                    />
                  </div>
                  <div class="key-content">NIFTY 100</div>
                </a>
              </li>
              <li>
                <a href="/indices/nifty-200-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="Nifty 200"
                    />
                  </div>
                  <div class="key-content">NIFTY 200</div>
                </a>
              </li>
              <li>
                <a href="/indices/nifty-500-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="Nifty 500"
                    />
                  </div>
                  <div class="key-content">NIFTY 500</div>
                </a>
              </li>
              <li>
                <a href="/indices/nifty-midcap-50-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="Nifty Midcap 50"
                    />
                  </div>
                  <div class="key-content">NIFTY MIDCAP 50</div>
                </a>
              </li>
              <li>
                <a href="/indices/nifty-smlcap-50-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="NIFTY SMLCAP 50"
                    />
                  </div>
                  <div class="key-content">NIFTY SMLCAP 50</div>
                </a>
              </li>
              <li>
                <a href="/indices/india-vix-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="India VIX"
                    />
                  </div>
                  <div class="key-content">INDIA VIX</div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section class="key-indices">
      <div class="container">
        <div class="key-indices-inner">
          <div class="key-indices-header">
            <h4>Key Indices in BSE</h4>
          </div>
          <div class="key-indices-content">
            <ul>
              <li>
                <a href="/indices/sensex-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="SENSEX"
                    />
                  </div>
                  <div class="key-content">SENSEX</div>
                </a>
              </li>
              <li>
                <a href="/indices/bse100-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="BSE100"
                    />
                  </div>
                  <div class="key-content">BSE100</div>
                </a>
              </li>
              <li>
                <a href="/indices/lrgcap-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="LRGCAP"
                    />
                  </div>
                  <div class="key-content">LRGCAP</div>
                </a>
              </li>
              <li>
                <a href="/indices/midcap-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="MIDCAP"
                    />
                  </div>
                  <div class="key-content">MIDCAP</div>
                </a>
              </li>
              <li>
                <a href="/indices/smlcap-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="SMLCAP"
                    />
                  </div>
                  <div class="key-content">SMLCAP</div>
                </a>
              </li>
              <li>
                <a href="/indices/bse500-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="BSE500"
                    />
                  </div>
                  <div class="key-content">BSE500</div>
                </a>
              </li>
              <li>
                <a href="/indices/allcap-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="ALLCAP"
                    />
                  </div>
                  <div class="key-content">ALLCAP</div>
                </a>
              </li>
              <li>
                <a href="/indices/bse200-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="BSE200"
                    />
                  </div>
                  <div class="key-content">BSE200</div>
                </a>
              </li>
              <li>
                <a href="/indices/bseipo-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="BSEIPO"
                    />
                  </div>
                  <div class="key-content">BSEIPO</div>
                </a>
              </li>
              <li>
                <a href="/indices/smeipo-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="SMEIPO"
                    />
                  </div>
                  <div class="key-content">SMEIPO</div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <!--------------------END Key Indicies Template--------------------------->

    <!-- Calculator Qna Section -->

    <section class="container calculator-info">
      <h2>What is Gratuity?</h2>
      <p></p>
      <p>
        Gratuity is a calculated amount of money paid by the employer to the
        employee as a token of gratitude for services rendered to the company.
        It is a benefit awarded to employees under the Payment of Gratuity Act,
        1972. It is included as one of the components of the salary break-up.
      </p>
      <p>
        Gratuity is awarded to the employee only upon completing 5 years or more
        with the company. It is paid at the time of retirement, resignation,
        lay-off or termination of the employee. The employee can be awarded
        Gratuity earlier in case of accident, disease or disability.
      </p>
      <p>
        The Gratuity earned depends on the last drawn salary of the employee as
        well as the number of years of service provided by him to the company.
      </p>
      <p></p>
      <h2>What is a Gratuity calculator?</h2>
      <p></p>
      <p>
        A Gratuity calculator is a handy tool to get an instant estimate of the
        amount an employee is eligible to get on leaving a job after rendering
        at least 5 years of service to a company. The inputs that are required
        to use this calculator are:
      </p>
      <p>
        1. The last drawn salary<br />
        2. Number of years served to company (including months)<br />
        3. Dearness Allowance
      </p>
      <p>
        The calculator uses these inputs to instantly tell you your Gratuity
        amount.
      </p>
      <p></p>
      <h2>How does a Gratuity calculator work?</h2>
      <p></p>
      <p>
        All the Gratuity rules &amp; calculations are based on the provisions of
        the Payment of Gratuity Act, 1972.
      </p>
      <p>
        Gratuity is calculated in two different ways for employees covered under
        the act and employees not covered under the act. In order to calculate
        the amount, the Gratuity calculator uses two perimeters; the total
        number of years that an employee has worked for the company and the
        employee’s last drawn salary. In the case of a government employee or
        employees with more structured salary break ups, an additional input for
        Dearness Allowance is required. There is no set percentage provided by
        law to calculate the Gratuity amount that an employee is eligible to
        receive after retirement or resignation.
      </p>
      <p></p>
      <h2>What is the Gratuity calculation formula?</h2>
      <p></p>
      <p>
        <b>For employees who are covered under the Payment of Gratuity Act</b>,
        the following formula is used to calculate the Gratuity amount:
      </p>
      <p>Gratuity = (a x b x 15) / 26,</p>
      <p>Where,</p>
      <p>a = Years of service</p>
      <p>b = Last drawn salary</p>
      <p>
        The basic salary and dearness allowance is included in the last drawn
        salary.
      </p>
      <p>
        For example: If Dhruv has served for 20 years in a company and his last
        drawn salary (including basic salary and dearness allowance) was Rs.
        30,000, then:
      </p>
      <p>
        Gratuity amount for Dhruv = (20&nbsp; x&nbsp; 30,000 x 15) / 26 = Rs.
        3,46,153.846
      </p>
      <p>
        <b>For employees not covered in the Gratuity Act</b>, the following
        formula is used to calculate the Gratuity amount:
      </p>
      <p>Gratuity = (a x b x 15) / 30</p>
      <p>
        Keeping in mind the same example, if Dhruv did not fall under the
        purview of the act, he would receive:
      </p>
      <p>
        Gratuity amount for Dhruv = (20&nbsp; x&nbsp; 30,000 x 15) / 30 = Rs.
        3,00,000
      </p>
      <p></p>
      <h2>What are the eligibility criteria for the payment of Gratuity?</h2>
      <p></p>
      <p>
        <span style="font-weight: 400"
          >The Gratuity calculation eligibility is determined by either of the
          following criteria:</span
        >
      </p>
      <ul>
        <li aria-level="1">
          The employee must be eligible for superannuation;
        </li>
        <li aria-level="1">The employee must be retired from service;</li>
        <li aria-level="1">
          The employee resigned after 5 years of uninterrupted employment with
          the company;
        </li>
        <li aria-level="1">
          The employee passes away or suffers a disability caused by an illness
          or an accident. The Gratuity is paid to the spouse or nominee in this
          case.
        </li>
      </ul>
      <p></p>
      <h2>What are the taxation rules for Gratuity?</h2>
      <p></p>
      <p>
        The taxation rules for Gratuity are conditional on the type of
        employment of the individual receiving the Gratuity.
      </p>
      <ul>
        <li aria-level="1">
          The Gratuity received by a government employee, irrespective of
          central, state or local authority, is exempt from income tax;
        </li>
        <li aria-level="1">
          The Gratuity received by an eligible private employee whose employer
          is covered under the Payment of Gratuity Act will receive a tax
          exemption on the least of the following amounts:
          <ul>
            <li aria-level="2">The eligibility Gratuity;</li>
            <li aria-level="2">The actual amount of Gratuity received;</li>
            <li aria-level="2">Rs. 20 lakh</li>
          </ul>
        </li>
      </ul>
      <p></p>
      <h2>What are the benefits of using a Gratuity calculator?</h2>
      <p></p>
      <p>
        The Upstox Employee Gratuity calculator is an easy to use tool that does
        not require any technical knowledge or expertise. It provides the
        Gratuity amount instantly within seconds, based on the Gratuity
        calculator formula. The calculator also helps one plan for retirement as
        well as long-term financial planning especially for those who wish to
        invest the amount smartly, for maximum returns.
      </p>
      <p><strong>Gratuity Calculation Chart:</strong></p>
      <p></p>
      <h2>How is Upstox the best online Gratuity Calculator?</h2>
      <p></p>
      <p>
        <span style="font-weight: 400"
          >Being a master player of the finance world, Upstox is committed to
          providing a seamless experience when it comes to your finances. Our
          online Gratuity calculator is built with the best user interface,
          making it easy to use, speedy &amp; comfortable. The Gratuity
          calculator is designed to help you align your financial goals &amp;
          current investments.</span
        >
      </p>
      <p></p>
    </section>
    <!-- Calculator Faqs Section-->

    <section class="faqs">
      <div class="container">
        <div class="faq-card nav-list" id="faq">
          <div class="faq-card-details stock-card-header">
            <div class="faq-card-desc">
              <h2 class="heading">Frequently Asked Questions</h2>
            </div>
          </div>
          <div class="stock-card-content dynamic-faq">
            <div class="panel panel-default">
              <div class="panel-heading" id="faq-1">
                <h3 class="panel-title">
                  <span class="panel-trigger" val="#collapse-1">
                    <span class="flex-grow"
                      >How can I calculate my Gratuity?</span
                    >
                    <div class="icon-arrow">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/faq-arrow.svg"
                        alt="How can I calculate my Gratuity?"
                      />
                    </div>
                  </span>
                </h3>
              </div>
              <div id="collapse-1" class="panel-collapse collapse">
                <div class="panel-body visible">
                  <p>
                    You can calculate your Gratuity using the Gratuity
                    calculator or the Gratuity calculation formula.
                  </p>
                  <p>
                    If you are covered under the Payment of Gratuity Act, the
                    following formula is used to calculate the Gratuity amount:
                  </p>
                  <p>Gratuity = (a x b x 15) / 26,</p>
                  <p>Where,</p>
                  <p>a = Years of service</p>
                  <p>b = Last drawn salary</p>
                  <p>
                    The basic salary and dearness allowance is included in the
                    last drawn salary.
                  </p>
                  <p>
                    For example: If you have served for 15 years in a company
                    and his last drawn salary (including basic salary and
                    dearness allowance) was Rs. 35,000, then:
                  </p>
                  <p>
                    Gratuity amount for you = (15&nbsp; x&nbsp; 35,000 x 15) /
                    26 = Rs. 3,02,884.615
                  </p>
                  <p>
                    If you are not covered in the Gratuity Act, the following
                    formula is used to calculate the Gratuity amount:
                  </p>
                  <p>Gratuity = (a x b x 15) / 30</p>
                  <p>
                    Keeping in mind the same example, if you did not fall under
                    the purview of the act, you would receive:
                  </p>
                  <p>
                    Gratuity amount for you = (15&nbsp; x&nbsp; 35,000 x 15) /
                    30 = Rs. 2,62,500
                  </p>
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading" id="faq-2">
                <h3 class="panel-title">
                  <span class="panel-trigger" val="#collapse-2">
                    <span class="flex-grow"
                      >How do you calculate Employee Gratuity?</span
                    >
                    <div class="icon-arrow">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/faq-arrow.svg"
                        alt="How do you calculate Employee Gratuity?"
                      />
                    </div>
                  </span>
                </h3>
              </div>
              <div id="collapse-2" class="panel-collapse collapse">
                <div class="panel-body visible">
                  <p>
                    The employer can calculate employee Gratuity using the
                    Gratuity calculator or the Gratuity calculation formula.
                  </p>
                  <p>
                    In order to calculate the Gratuity of an employee covered
                    under the Payment of Gratuity Act, the employer must use the
                    following formula to calculate the Gratuity amount:
                  </p>
                  <p>Gratuity = (a x b x 15) / 26,</p>
                  <p>Where,</p>
                  <p>a = Years of service</p>
                  <p>b = Last drawn salary</p>
                  <p>
                    The basic salary and dearness allowance is included in the
                    last drawn salary.
                  </p>
                  <p>
                    If the employee is not covered in the Gratuity Act, the
                    employer must use the following formula to calculate the
                    Gratuity amount:
                  </p>
                  <p>Gratuity = (a x b x 15) / 30</p>
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading" id="faq-3">
                <h3 class="panel-title">
                  <span class="panel-trigger" val="#collapse-3">
                    <span class="flex-grow"
                      >Is Gratuity calculator different for private &amp;
                      government employees?</span
                    >
                    <div class="icon-arrow">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/faq-arrow.svg"
                        alt="Is Gratuity calculator different for private &amp; government employees?"
                      />
                    </div>
                  </span>
                </h3>
              </div>
              <div id="collapse-3" class="panel-collapse collapse">
                <div class="panel-body visible">
                  <p>
                    The Gratuity calculation formula for private and government
                    employees is the same. However, there is a difference in tax
                    payable for the two kinds of employees. The Gratuity
                    received by government employees, irrespective of central,
                    state or local authority, is entirely exempt from income
                    tax. On the other hand, Gratuity received by private-sector
                    employees is taxable. However, they will receive a tax
                    exemption on the least of the following amounts:
                  </p>
                  <ul style="list-style: disc">
                    <li aria-level="1">The eligibility Gratuity;</li>
                    <li aria-level="1">
                      The actual amount of Gratuity received;
                    </li>
                    <li aria-level="1">Rs. 20 lakh</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading" id="faq-4">
                <h3 class="panel-title">
                  <span class="panel-trigger" val="#collapse-4">
                    <span class="flex-grow"
                      >What is the percentage of Gratuity?</span
                    >
                    <div class="icon-arrow">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/faq-arrow.svg"
                        alt="What is the percentage of Gratuity?"
                      />
                    </div>
                  </span>
                </h3>
              </div>
              <div id="collapse-4" class="panel-collapse collapse">
                <div class="panel-body visible">
                  <p>
                    There is no set percentage provided by law to calculate the
                    Gratuity amount that an employee is eligible to receive
                    after retirement or resignation.
                  </p>
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading" id="faq-5">
                <h3 class="panel-title">
                  <span class="panel-trigger" val="#collapse-5">
                    <span class="flex-grow"
                      >How is tax on Gratuity calculated?</span
                    >
                    <div class="icon-arrow">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/faq-arrow.svg"
                        alt="How is tax on Gratuity calculated?"
                      />
                    </div>
                  </span>
                </h3>
              </div>
              <div id="collapse-5" class="panel-collapse collapse">
                <div class="panel-body visible">
                  <p>
                    The tax treatment is different for Private &amp; Government
                    sector employees. For government employees, all Gratuity is
                    tax free or tax exempt, but they still need to fill it out
                    in their ITR forms.
                  </p>
                  <p>
                    Private sector employees on the other hand, the tax
                    exemption is given on the lesser of the 3 amounts of the
                    following:
                  </p>
                  <ol>
                    <li aria-level="1">Eligible Gratuity</li>
                    <li aria-level="1">Actual Gratuity</li>
                    <li aria-level="1">
                      Rs. 20,00,000 (effective from March 29, 2018)
                    </li>
                  </ol>
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading" id="faq-6">
                <h3 class="panel-title">
                  <span class="panel-trigger" val="#collapse-6">
                    <span class="flex-grow"
                      >How can a Gratuity calculator help you?</span
                    >
                    <div class="icon-arrow">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/faq-arrow.svg"
                        alt="How can a Gratuity calculator help you?"
                      />
                    </div>
                  </span>
                </h3>
              </div>
              <div id="collapse-6" class="panel-collapse collapse">
                <div class="panel-body visible">
                  <p>
                    Calculating the Gratuity can be a long and tedious process,
                    prone to human error. A Gratuity calculator uses the
                    Gratuity formula and ensures a correct and swift response.
                  </p>
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading" id="faq-7">
                <h3 class="panel-title">
                  <span class="panel-trigger" val="#collapse-7">
                    <span class="flex-grow"
                      >How to calculate Gratuity on retirement?</span
                    >
                    <div class="icon-arrow">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/faq-arrow.svg"
                        alt="How to calculate Gratuity on retirement?"
                      />
                    </div>
                  </span>
                </h3>
              </div>
              <div id="collapse-7" class="panel-collapse collapse">
                <div class="panel-body visible">
                  <p>
                    The retirement Gratuity calculation formula is payable to an
                    employee upon retirement, provided they worked for a minimum
                    of 5 years for the company. It is calculated basis his last
                    drawn monthly salary and Dearness Allowance.
                  </p>
                  <p>
                    Calculation of Gratuity on retirement = (Years of Service x
                    Last drawn basic monthly salary x 15) / 26
                  </p>
                  <p>
                    26 here stands for the number of working days in the month.
                  </p>
                  <p>
                    So, for example, Amir joined ABC at age 25 years &amp;
                    retired at 60. His basic salary at 60 was 2,00,000. Basis
                    this his Gratuity will be:
                  </p>
                  <p>(35 x 2,00,000 x 15)/26<b> = Rs. 40,38,461</b></p>
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading" id="faq-8">
                <h3 class="panel-title">
                  <span class="panel-trigger" val="#collapse-8">
                    <span class="flex-grow"
                      >How much time does an employer take to pay the Gratuity
                      amount?</span
                    >
                    <div class="icon-arrow">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/faq-arrow.svg"
                        alt="How much time does an employer take to pay the Gratuity amount?"
                      />
                    </div>
                  </span>
                </h3>
              </div>
              <div id="collapse-8" class="panel-collapse collapse">
                <div class="panel-body visible">
                  <p>
                    The employer and employee must undergo a three-step process
                    in order to complete the Gratuity process.
                  </p>
                  <ol>
                    <li aria-level="1">
                      Initiation: The employee must send an application to the
                      employer regarding their Gratuity amount.
                    </li>
                    <li aria-level="1">
                      Acknowledgement &amp; Calculation: As soon as the employer
                      receives the application, the company must immediately
                      begin the Gratuity amount calculation. They must also
                      provide a notice of acknowledgement to the employee &amp;
                      the controlling authority with the Gratuity amount
                      specified.
                    </li>
                    <li aria-level="1">
                      Disbursal: The employer must disburse the gratuity amount
                      to the employee within 30 days of acknowledgement.
                    </li>
                  </ol>
                  <p>
                    If there is a delay in payment, the employer is liable to
                    pay simple interest until the day of payment.
                  </p>
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading" id="faq-9">
                <h3 class="panel-title">
                  <span class="panel-trigger" val="#collapse-9">
                    <span class="flex-grow"
                      >Is there any upper cap on Gratuity?</span
                    >
                    <div class="icon-arrow">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/faq-arrow.svg"
                        alt="Is there any upper cap on Gratuity?"
                      />
                    </div>
                  </span>
                </h3>
              </div>
              <div id="collapse-9" class="panel-collapse collapse">
                <div class="panel-body visible">
                  <p>
                    Yes, there is an upper cap or Rs. 20 lakh, of the Gratuity
                    that an employee is eligible to receive, regardless of the
                    number of years the employee has been in service and their
                    previous drawn salary.
                  </p>
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading" id="faq-10">
                <h3 class="panel-title">
                  <span class="panel-trigger" val="#collapse-10">
                    <span class="flex-grow"
                      >How is Gratuity calculated in salary break-up?</span
                    >
                    <div class="icon-arrow">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/faq-arrow.svg"
                        alt="How is Gratuity calculated in salary break-up?"
                      />
                    </div>
                  </span>
                </h3>
              </div>
              <div id="collapse-10" class="panel-collapse collapse">
                <div class="panel-body visible">
                  <p>
                    The Gratuity is calculated based on the basic salary &amp;
                    Dearness Allowance. It is 4.81% of the basic salary and
                    mentioned separately in the salary break up.
                  </p>
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading" id="faq-11">
                <h3 class="panel-title">
                  <span class="panel-trigger" val="#collapse-11">
                    <span class="flex-grow"
                      >Is Gratuity deducted from salary every month?</span
                    >
                    <div class="icon-arrow">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/faq-arrow.svg"
                        alt="Is Gratuity deducted from salary every month?"
                      />
                    </div>
                  </span>
                </h3>
              </div>
              <div id="collapse-11" class="panel-collapse collapse">
                <div class="panel-body visible">
                  <p>
                    No, the Gratuity amount is the amount owed by the employer
                    to an employee as a token of gratitude for service of 5
                    years or more. The employer cannot deduct this from the
                    employee salary, instead they must make a separate provision
                    for the same. The Gratuity is often separated from base
                    salary (4.81%) and is mentioned in the gross salary break
                    up.
                  </p>
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading" id="faq-12">
                <h3 class="panel-title">
                  <span class="panel-trigger" val="#collapse-12">
                    <span class="flex-grow">What is the rule of Gratuity?</span>
                    <div class="icon-arrow">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/faq-arrow.svg"
                        alt="What is the rule of Gratuity?"
                      />
                    </div>
                  </span>
                </h3>
              </div>
              <div id="collapse-12" class="panel-collapse collapse">
                <div class="panel-body visible">
                  <p>
                    The rule of Gratuity includes the forfeiture of Gratuity
                    &amp; the timeline for Gratuity payment.
                  </p>
                  <p><b>Forfeiture of Gratuity</b></p>
                  <p>
                    As per the Payment of Gratuity Act of 1972, the employer has
                    the right to forfeit the Gratuity payment, fully or
                    partially even if the employees have served their 5 years or
                    more in the company. This is eligible in the case that the
                    employee has been terminated from the company due to
                    disorderly conduct when they may have tried to physically
                    harm another individual during their employment.
                  </p>
                  <p><b>Timeline for Gratuity payment</b></p>
                  <p>Gratuity payment is a 3 step process:</p>
                  <p>
                    Step 1: Initiation: The employee must send an application to
                    the employer for their Gratuity amount.
                  </p>
                  <p>
                    Step 2: Acknowledgement &amp; Calculation: As soon as the
                    application is received by the employer, the company will
                    immediately start the Gratuity amount calculation as well as
                    provide a notice of acknowledgement to the employee &amp;
                    the controlling authority with the amount specified.
                  </p>
                  <p>
                    Step 3: Disbursal: The Gratuity amount will be disbursed by
                    the employer to the employee within 30 days of
                    acknowledgement.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Similar Calculator Section-->
    <!-- text start similar-->
    <section class="similar_section">
      <div class="container">
        <div class="heading-wrap">
          <h2 class="fs-28 bold help_here">Similar Calculator</h2>
          <button class="similar-btn btn-all">View all</button>
          <button class="similar-btn btn-less" style="display: none">
            View less
          </button>
        </div>
        <div class="smooth-wrap">
          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Brokerage Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Margin Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Mutual Fund Returns Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> SIP Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> NPV Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Future Value Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> SWP Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> ELSS Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Option Value Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> NPS Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> PPF Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Compound Annual Growth Rate Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> National Savings Certificate Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Sukanya Samriddhi Yojana Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Compound Interest Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Atal Pension Yojana Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Simple Interest Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Fixed Deposit Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> GST Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> HRA Calculator</a>
            </h3>
          </div>
        </div>
      </div>
    </section>
    <!-- Calculator Disclaimer Section -->
    <section class="container calculator-disclaimer">
      <p></p>
      <p>
        Disclaimer:<br />
        This calculator is meant to be used for indicative purposes only. It is
        designed to assist you in determining the appropriate amount of
        prospective investments. This calculator alone is not sufficient and
        shouldn’t be used for the development or implementation of any
        investment strategy. Upstox does not take the responsibility/liability
        nor does it undertake the authenticity of the figures calculated
        therein. Upstox makes no warranty about the accuracy of the
        calculators/reckoners. The examples do not claim to represent the
        performance of any security or investments. In view of the individual
        nature of tax consequences, each investor is advised to consult his/her
        own professional tax advisor before making any investment decisions on
        the basis of the results provided through the use of this calculator.
      </p>
      <p></p>
    </section>
  </main>
</template>
<style scoped>
</style>
